export default __webpack_public_path__ + "static/job-openings-796f9a955804cf98d46a3e25d9497799.svg";